import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../services";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class EpicGuardService {
    private authService = inject(AuthService);


    async canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) : Promise<boolean> {
        const user = await this.authService.getAuthUser();
        const isEpic = user?.isEpic ? true : false;
    
        if (!isEpic) {
          const errorMessage = 'Unauthorized: User does not have permission to access this page.';
          location.href = environment.manageAccountUrl + 'error?errorMessage=' + errorMessage;
          return false;
        }
        return true;
    }
} 

export const EpicGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Promise<boolean> => {
    return await inject(EpicGuardService).canActivate(next, state);
}